import { Injectable } from '@angular/core';
import { apiUrl } from '../constants/apiUrl';
import { HttpRequestService } from '../services/http-request.service';

@Injectable({
    providedIn: 'root',
})
export class MessageApi {
    constructor(
        private httpRequestService: HttpRequestService,
    ) {}

    async getMessage() {
        const result = await this.httpRequestService.axiosGetWithToken(
            apiUrl.message
        );
        return result.data || [];
    }

    async setReadAllMessage() {
        const result = await this.httpRequestService.axiosPutWithToken(
            apiUrl.messageRead
        );
        return result.data;
    }

    async setReadMessageById(messageId: number) {
        const result = await this.httpRequestService.axiosPutWithToken(
            `${apiUrl.messageRead}/${messageId}`
        );
        return result.data;
    }
}
